import { useId } from 'react'
import { Card, Table } from '@design-systems/canvas-ui'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { useEssentials } from 'hooks/utils/useEssentials'
import { StoreSnapshot } from 'types/insights'
import { buildSnapshotRows } from './utils'
import { NoData } from '../no-data/no-data'

interface StoreDistrictSnapshotProps {
    data: StoreSnapshot
}

export const StoreDistrictSnapshot: React.FC<StoreDistrictSnapshotProps> = ({
    data,
}) => {
    const { insights } = TRANSLATION_KEYS
    const { t, currentLocation } = useEssentials()
    const headingId = useId()

    const formattedData = buildSnapshotRows(data)

    const customColumnDefs = [
        {
            id: 'metric',
            header: t(insights.storeDistrictSnapshot.metric),
            isRowHeader: true,
            meta: { size: 75, pinned: true },
            pinned: true,
        },
        {
            id: 'value',
            header: currentLocation,
            meta: { size: 90 },
        },
        {
            id: 'district',
            header: t(insights.storeDistrictSnapshot.district),
            meta: { size: 75 },
        },
        {
            id: 'takeaway',
            header: t(insights.storeDistrictSnapshot.takeaway),
            meta: { size: 300 },
        },
    ]

    return (
        <section aria-labelledby={headingId}>
            <h2 id={headingId} className="hc8-mb-3x hc8-fs-250">
                {t(insights.storeDistrictSnapshot.header)}
            </h2>
            <Card className="hc8-ma-none table-scroll-container">
                {formattedData.length === 0 ? (
                    <NoData />
                ) : (
                    <Table
                        className="hc8-clr-base hc8-ma-none"
                        name={t(insights.storeDistrictSnapshot.header)}
                        isCornerRounded={true}
                        alternateRowColor={false}
                        data={{
                            columnDefs: customColumnDefs,
                            rowData: formattedData,
                        }}
                    />
                )}
            </Card>
        </section>
    )
}
